import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_GridCol = _resolveComponent("GridCol")!
  const _component_GridRow = _resolveComponent("GridRow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.showAutomatedGrid || _ctx.checkForAutomatedGrid)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
          key: 0,
          class: _normalizeClass(_ctx.classes),
          ref: "list"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItems, (item, inx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `list-item-${inx}`
              }, [
                (_ctx.type === 'icon')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: _ctx.icon,
                      class: _normalizeClass(["fa-li", `color-${_ctx.iconColor}`])
                    }, [
                      _createVNode(_component_FaIcon, { icon: _ctx.icon }, null, 8, ["icon"])
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  ref: el => { if (el) { _ctx.listElements.push(el) } },
                  innerHTML: item
                }, null, 8, _hoisted_1)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    (_ctx.showAutomatedGrid && !_ctx.checkForAutomatedGrid)
      ? (_openBlock(), _createBlock(_component_GridRow, {
          key: 1,
          g: "0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_GridCol, { s: "6" }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
                  class: _normalizeClass(_ctx.classes),
                  ref: "list"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItemsEven, (item, inx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `list-item-${inx}`
                      }, [
                        (_ctx.type === 'icon')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: _ctx.icon,
                              class: _normalizeClass(["fa-li", `color-${_ctx.iconColor}`])
                            }, [
                              _createVNode(_component_FaIcon, { icon: _ctx.icon }, null, 8, ["icon"])
                            ], 2))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", {
                          ref: el => { if (el) { _ctx.listElements.push(el) } },
                          innerHTML: item
                        }, null, 8, _hoisted_2)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["class"]))
              ]),
              _: 1
            }),
            _createVNode(_component_GridCol, { s: "6" }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
                  class: _normalizeClass(_ctx.classes),
                  ref: "list"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItemsOdd, (item, inx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `list-item-${inx}`
                      }, [
                        (_ctx.type === 'icon')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: _ctx.icon,
                              class: _normalizeClass(["fa-li", `color-${_ctx.iconColor}`])
                            }, [
                              _createVNode(_component_FaIcon, { icon: _ctx.icon }, null, 8, ["icon"])
                            ], 2))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", {
                          ref: el => { if (el) { _ctx.listElements.push(el) } },
                          innerHTML: item
                        }, null, 8, _hoisted_3)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["class"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}